import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { Card, Fade, Container, Col, Row } from 'reactstrap';
import styled from 'styled-components';
import {
    TitleRow,
    ColAlignRight,
    StyledNavIconNoMarginRight,
    HoverButton,
    Title,
    SubTitle
} from '../../styles/common';
import { AppDispatchContext, AppStateContext } from '../../context/AppContext';

const CardBody = styled(Card)`
    ${($transparentCard) => $transparentCard ? 'padding: 0px;' : 'padding: 24px;'}
    color: ${({ theme }) => theme.typography.text} !important;
    ${($transparentCard) => $transparentCard ? 'background-color: transparent !important;':  `background-color: ${({ theme }) => theme.colors.foreground} !important;`}
    height: 100% !important;
    ${({ $roundedCorner }) => $roundedCorner && 'border-radius: 20px !important;'}
    ${({ $width }) => $width && 'width: 560px !important;'}
    ${($transparentCard) => $transparentCard && 'border: none;'}
`;
const CardWrapper = styled.div`
    height: 100% !important;
`;
const StyledFade = styled(Fade)`
    height: 100% !important;
`;
const CardContainer = styled(Container)`
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    ${({ $wideMode }) => $wideMode && 'max-width: 100% !important;'}
`;
const BodyRow = styled(Row)`
    flex-grow: 1 !important;
`;

const CardTemplate = ({
    testId,
    noFade,
    title,
    subtitle,
    icon,
    children,
    wideModeEnabled = false,
    roundedCorner,
    width,
    transparentCard
}) => {
    const dispatch = useContext(AppDispatchContext);
    const { wideMode } = useContext(AppStateContext);

    return (
        <CardWrapper data-test-id={testId}>
            <StyledFade timeout={200} appear={noFade}>
                <CardContainer $wideMode={wideModeEnabled && wideMode}>
                    <TitleRow>
                        <Col>
                            <Title>{`${title} ${icon}`}</Title>
                        </Col>
                        {wideModeEnabled && (
                            <ColAlignRight>
                                <HoverButton
                                    size="sm"
                                    onClick={() =>
                                        dispatch({ type: 'TOGGLE_WIDE_MODE' })
                                    }
                                >
                                    <StyledNavIconNoMarginRight
                                        icon={
                                            wideMode
                                                ? 'compress-alt'
                                                : 'expand-alt'
                                        }
                                        transform={{ rotate: 45 }}
                                    />
                                </HoverButton>
                            </ColAlignRight>
                        )}
                    </TitleRow>
                    {subtitle && (
                        <Row>
                            <Col>
                                <SubTitle>{subtitle}</SubTitle>
                            </Col>
                        </Row>
                    )}
                    <BodyRow>
                        <Col>
                            <CardBody $roundedCorner={roundedCorner} $width={width} $transparentCard={transparentCard}>{children}</CardBody>
                        </Col>
                    </BodyRow>
                </CardContainer>
            </StyledFade>
        </CardWrapper>
    );
};

CardTemplate.propTypes = {
    noFade: PropTypes.bool,
    roundedCorner:PropTypes.bool,
    width:PropTypes.bool,
    testId: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string,
    children: PropTypes.node,
    subtitle: PropTypes.string,
    transparentCard: PropTypes.bool,
};

CardTemplate.defaultProps = {
    noFade: false,
    roundedCorner:false,
    width:false,
    testId: '',
    title: '',
    icon: '',
    children: null,
    subtitle: null,
    transparentCard: false,
};

export default CardTemplate;
